import { useCallback } from 'react';
import { Form } from 'react-final-form';
import { Box } from '@mui/material';

import { TextField, ConfirmDialog, LinearProgress } from '@occc-app/design-system';

import { validateLocationGroup } from '../../components/location-group-update-dialog/location-group-update-dialog.validation';
import { LocationGroupFormValues } from '../../components/location-group-update-dialog/location-group-update-dialog.types';

type LocationGroupCreateDialogProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: (values: LocationGroupFormValues) => void;
  loading: boolean;
};

export const LocationGroupCreateDialog = ({
  open,
  onClose,
  onSubmit,
  loading,
}: LocationGroupCreateDialogProps) => {
  const renderForm = useCallback(() => {
    return <TextField name='name' label='Group Name' />;
  }, []);

  return (
    <Form<LocationGroupFormValues>
      onSubmit={onSubmit}
      validate={validateLocationGroup}
      render={({ handleSubmit, valid }) => {
        return (
          <ConfirmDialog
            dialogTitle='New Group'
            onClose={onClose}
            open={open}
            maxWidth='xs'
            confirmButtonText='Create Group'
            confirmButtonProps={{
              onClick: handleSubmit,
              disabled: !valid || loading,
            }}
          >
            {loading && <LinearProgress />}
            <Box mt={1}>{renderForm()}</Box>
          </ConfirmDialog>
        );
      }}
    />
  );
};
